import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import { IPharmaInventoryCreate } from "src/types/GlobalInterfaces";

interface IProps {
  state: IPharmaInventoryCreate;
  setState: React.Dispatch<React.SetStateAction<IPharmaInventoryCreate>>;
  tabChange: () => void;
}

const InventoryImagesTab: React.FC<IProps> = ({
  state,
  setState,
  tabChange,
}) => {
  const addNewGalleryImage = () => {
    setState((prev) => ({
      ...prev,
      galleryImages: [...prev.galleryImages, ""],
    }));
  };

  const changeGalleryImages = (
    file: File | null,
    index: number,
    previous: string = ""
  ) => {
    if (file) {
      setState((prev) => ({
        ...prev,
        galleryImages: prev.galleryImages.map((prevImg, i) =>
          i === index ? file : prevImg
        ),
      }));
    } else {
      setState((prev) => ({
        ...prev,
        galleryImages: prev.galleryImages.filter((_, i) => i !== index),
      }));
    }
  };

  const changeBannerImages = (
    file: File | null,
    index: number,
    previous: string = ""
  ) => {
    // if (file) {
    var dFile = file || "";
    setState((prev) => ({
      ...prev,
      salesBanners: prev.salesBanners.map((prevImg, i) =>
        i === index ? dFile : prevImg
      ),
    }));
    // } else {
    //   setState((prev) => ({
    //     ...prev,
    //     salesBanners: prev.salesBanners.filter((_, i) => i !== index),
    //   }));
    // }
  };
  return (
    <>
      <div className="products-tabs-content">
        <div>
          <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
            Main Image
          </h3>
          <ImageUpload
            image={state?.image}
            allowedTypes={["image/png", "image/jpeg"]}
            allowedExtensions={[".jpg", ".jpeg", ".png"]}
            onImageChange={(file: File | null) => {
              setState((prev) => ({ ...prev, image: file }));
            }}
            extraClasses={"w-full min-h-[200px]"}
            labelId="main-image-label"
          />
        </div>
        <div>
          <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
            Gallery Images
          </h3>
          <div className="flex flex-row flex-wrap gap-5">
            {state?.galleryImages?.map((v, index: number) => (
              <ImageUpload
                key={index}
                image={v}
                allowedTypes={["image/png", "image/jpeg"]}
                allowedExtensions={[".jpg", ".jpeg", ".png"]}
                onImageChange={(file: File | null) => {
                  changeGalleryImages(file, index);
                }}
                labelId={`gallery-image-label-${index + 1}`}
              />
            ))}
          </div>

          <div className="flex justify-end">
            <PrimaryBtn
              disabled={state?.galleryImages?.length > 9}
              btnExtralClasses={`px-4 py-1 font-size-13px ${
                state?.galleryImages?.length > 9 ? "cursor-not-allowed" : ""
              }`}
              ButtonText="Add New"
              btnExtraStyle={{
                backgroundColor: "#00443f",
                borderRadius: "1.5rem",
              }}
              onPress={addNewGalleryImage}
              id="add-new-gallery-image-btn"
            />
          </div>
        </div>
      </div>
      <button
        className="flex gap-2 items-center underline font-Poppins-Medium font-size-18px text-[#00443F] my-3"
        onClick={() => {
          setState((prev: IPharmaInventoryCreate) => ({
            ...prev,
            salesBanners: prev?.salesBanners?.length > 0 ? [] : ["", ""],
          }));
        }}
        id="sales-banners-btn"
      >
        <FontAwesomeIcon
          icon={state?.salesBanners?.length > 0 ? faMinus : faPlus}
          size="sm"
        />{" "}
        {state?.salesBanners?.length > 0
          ? "Remove Sales Banners"
          : "Add Sales Banners"}
      </button>
      {state?.salesBanners?.length > 0 && (
        <div className="products-tabs-content">
          {state?.salesBanners?.map((item, index) => (
            <div>
              <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
                Sales Banner Image (Optional)
              </h3>
              <ImageUpload
                image={item}
                allowedTypes={["image/png", "image/jpeg"]}
                allowedExtensions={[".jpg", ".jpeg", ".png"]}
                onImageChange={(file: File | null) => {
                  changeBannerImages(file, index);
                }}
                extraClasses={"w-full min-h-[200px]"}
                labelId={`sales-banner-image-label-${index + 1}`}
              />
            </div>
          ))}
        </div>
      )}
      <div className="flex justify-end my-6">
        <PrimaryBtn
          ButtonText="Back"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={tabChange}
          id="back-btn"
        />
      </div>
    </>
  );
};

export default InventoryImagesTab;
